import styled from 'styled-components'

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme }) => theme.sizing.margin.sm};
    margin-left: auto;
    max-width: 50%;
    width: 50%;

    @media (max-width: ${({ theme }) => theme.breakPoints.xl}) {
        width: 100%;
        max-width: 100%;
    }
`
